module.exports = __webpack_public_path__ + "img/bookmark.f0a10bd3.svg";